import { get } from 'lodash';

import * as BillApi from '@/api/bill';
import { renderIntlLabel } from '@/utils';
import actionTypes from './actionType';

const initBillSubjects = () => {
  return async (dispatch) => {
    const res = await BillApi.fetchBillSubjects();
    const resSubjects = get(res, 'data', []);

    const fullSubjects = resSubjects.map((sub) => {
      return {
        ...sub,
        value: sub.code,
        label: sub.name,
      };
    });
    fullSubjects.unshift({
      value: 'all',
      label: renderIntlLabel('app_search_form_option_label_all'),
    });
    dispatch({
      type: actionTypes.INIT_BILL_SUBJECTS,
      payload: {
        subjects: fullSubjects,
      },
    });
  };
};

const initConsumeSubjects = () => {
  return async (dispatch) => {
    const res = await BillApi.fetchConsumeSubjects();
    const resSubjects = get(res, 'data', []);

    const consumeSubjects = resSubjects.map((sub) => {
      return {
        value: sub.code,
        label: sub.name,
      };
    });
    dispatch({
      type: actionTypes.INIT_CONSUME_SUBJECTS,
      payload: {
        consumeSubjects,
      },
    });
  };
};

const initPaymentSubjects = () => {
  return async (dispatch) => {
    const res = await BillApi.fetchPaymentSubjects();
    const resSubjects = get(res, 'data', []);

    const paymentSubjects = resSubjects.map((sub) => {
      return {
        value: sub.code,
        label: sub.name,
      };
    });
    dispatch({
      type: actionTypes.INIT_PAYMENT_SUBJECTS,
      payload: {
        paymentSubjects,
      },
    });
  };
};

const setBillStatsLoading = (loading) => {
  return {
    type: actionTypes.SET_BILL_STATS_LOADING,
    payload: {
      billStatsLoading: loading,
    },
  };
};

const initBillStats = (params) => {
  return async (dispatch) => {
    dispatch(setBillStatsLoading(true));
    try {
      const res = await BillApi.fetchBillStats(params);
      dispatch(setBillStatsLoading(false));
      dispatch({
        type: actionTypes.INIT_BILL_STATS,
        payload: {
          billStats: get(res, 'data', {}),
        },
      });
      dispatch({
        type: actionTypes.SET_ORDER_BILL_STATUS,
        payload: {
          orderBillStatus: get(res, 'data.status', -1),
        },
      });
      dispatch({
        type: actionTypes.SET_ORDER_BILL_NO,
        payload: {
          orderBillNo: get(res, 'data.no', ''),
        },
      });
    } catch (err) {
      dispatch(setBillStatsLoading(false));
    }
  };
};

const resetBillStats = () => {
  return {
    type: actionTypes.RESET_BILL_STATS,
    payload: {},
  };
};

const setBillListLoading = (loading) => {
  return {
    type: actionTypes.SET_BILL_LIST_LOADING,
    payload: {
      billListLoading: loading,
    },
  };
};

const initBillList = (params) => {
  return async (dispatch) => {
    dispatch(setBillListLoading(true));
    try {
      const res = await BillApi.fetchBillList(params);
      dispatch(setBillListLoading(false));
      const bills = get(res, 'data', []);

      // flattern array
      const billList = bills.reduce((prev, cur) => {
        return Array.prototype.concat.call(prev, cur, cur.subs || []);
      }, []);
      dispatch({
        type: actionTypes.INIT_BILL_LIST,
        payload: {
          billList,
        },
      });
    } catch (err) {
      dispatch(setBillListLoading(false));
    }
  };
};

const resetBillList = () => {
  return {
    type: actionTypes.RESET_BILL_LIST,
    payload: {},
  };
};

const updateBillList = (list) => {
  return {
    type: actionTypes.UPDATE_BILL_LIST,
    payload: {
      billList: list,
    },
  };
};

const setListFilterParams = (filterParams) => {
  return {
    type: actionTypes.SET_LIST_FILTER_PARAMS,
    payload: {
      filterParams,
    },
  };
};

const setSelectedBills = (bills) => {
  return {
    type: actionTypes.SET_SELECTED_BILLS,
    payload: {
      selectedBills: bills,
    },
  };
};

const setSelectedBillIds = (billIds) => {
  return {
    type: actionTypes.SET_SELECTED_BILL_IDS,
    payload: {
      selectedBillIds: billIds,
    },
  };
};

const setBillRoomsLoading = (loading) => {
  return {
    type: actionTypes.SET_BILL_ROOMS_LOADING,
    payload: {
      roomsLoading: loading,
    },
  };
};

const initBillRooms = (params) => {
  return async (dispatch) => {
    setBillRoomsLoading(true);
    try {
      const res = await BillApi.fetchBillRooms(params);
      setBillRoomsLoading(false);
      dispatch({
        type: actionTypes.INIT_BILL_ROOMS,
        payload: {
          rooms: get(res, 'data', []),
        },
      });
    } catch (err) {
      setBillRoomsLoading(false);
    }
  };
};

const resetBillRooms = () => {
  return {
    type: actionTypes.RESET_BILL_ROOMS,
    payload: {},
  };
};

const setSelectedRoom = (room) => {
  return {
    type: actionTypes.SET_SELECTED_ROOM,
    payload: {
      selectedRoom: { ...room },
    },
  };
};

const setSettlementNo = (settlementNo) => {
  return {
    type: actionTypes.SET_SETTLEMENT_NO,
    payload: {
      settlementNo,
    },
  };
};

const setSettlementAction = (settlementAction) => {
  return {
    type: actionTypes.SET_SETTLEMENT_ACTION,
    payload: {
      settlementAction,
    },
  };
};

const initOrderMaster = (params) => {
  return async (dispatch) => {
    try {
      const res = await BillApi.fetchOrderMaster(params);
      dispatch({
        type: actionTypes.SET_ORDER_MASTER,
        payload: {
          orderMasterUid: get(res, 'data.masterWyuid', ''),
          orderMasterInfo: {
            roomId: get(res, 'data.masterRoomId', 0),
            roomNo: get(res, 'data.masterRoomNo', ''),
            recNo: get(res, 'data.masterRecNo', ''),
          },
        },
      });
    } catch (err) {
      dispatch({
        type: actionTypes.SET_ORDER_MASTER,
        payload: {
          orderMasterUid: '',
          orderMasterInfo: null,
        },
      });
    }
  };
};

const initMasterInfo = (params) => {
  return async (dispatch) => {
    try {
      const res = await BillApi.fetchMasterInfoByOrderNo(params);
      dispatch({
        type: actionTypes.INIT_MASTER_INFO,
        payload: {
          masterInfo: {
            certNo: get(res, 'data.certNo', ''),
            name: get(res, 'data.name', ''),
          },
        },
      });
    } catch (err) {
      dispatch({
        type: actionTypes.INIT_MASTER_INFO,
        payload: {
          masterInfo: {
            certNo: '',
            name: '',
          },
        },
      });
    }
  };
};

export {
  initBillSubjects,
  initConsumeSubjects,
  initPaymentSubjects,
  initBillStats,
  resetBillStats,
  initBillList,
  resetBillList,
  updateBillList,
  setListFilterParams,
  setSelectedBills,
  setSelectedBillIds,
  initBillRooms,
  resetBillRooms,
  setSelectedRoom,
  setSettlementNo,
  setSettlementAction,
  initOrderMaster,
  initMasterInfo,
};
